<template>
	<v-container fluid>

		<v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000" absolute>

			{{ message }}

			<v-btn dark text @click="snackbar = false">

				CLOSE

			</v-btn>

		</v-snackbar>

		<v-row>

			<v-col cols="12">

				<v-card>

					<v-card-title>

						<v-container fluid>

							<v-card class="pa-3">

								<!-- First Row: Center-aligned text -->

								<v-row justify="center">

									<v-col cols="12" class="text-center">

										<h5>Grower Name: {{ accountName }}</h5>

									</v-col>

								</v-row>



								<!-- Second Row: Two columns with text aligned left and right -->

								<v-row>

									<v-col cols="6" class="text-left">

										<p>DSS Settlement Account Number: {{ accountNumber }}</p>

									</v-col>

									<v-col cols="6" class="text-right">

										<p>DSS Settlement Account Name: {{ accountName }}</p>

									</v-col>

								</v-row>



								<!-- Third Row: Two columns with text aligned left and button aligned right -->

								<v-row>

									<v-col cols="6" class="text-left">

										<p>Book Balance: {{ currencyCode }} {{ availableBalance }}</p>

									</v-col>

									<v-col cols="6" class="text-right">

										<v-btn color="primary" @click="exportExcel">Download</v-btn>

									</v-col>

								</v-row>

							</v-card>

						</v-container>

						<v-row align="center" justify="start" no-gutters>

							<v-col :cols="12" :md="3" :sm="3" class="pa-2">

								<v-text-field v-model="search" append-icon="search" label="" class="w-100"></v-text-field>

							</v-col>

							<v-col :cols="12" :md="3" :sm="3" class="pa-2">

								<!-- <v-text-field v-model="amount" append-icon="search" label="Amount" class="w-100"></v-text-field> -->

							</v-col>



							<v-col :cols="12" :md="2" :sm="2" class="pa-2">

								<!-- <v-text-field label="Start Date" v-model="startDate" type="date" class="w-100"></v-text-field> -->

							</v-col>



							<v-col :cols="12" :md="2" :sm="2" class="pa-2">

								<!-- <v-text-field label="End Date" v-model="endDate" type="date" class="w-100"></v-text-field> -->

							</v-col>



							<v-col :cols="12" :md="2" :sm="2" class="pa-2">

								<!-- <v-btn @click="this.getSalesStatement" class="w-100 secondary">Search</v-btn> -->

							</v-col>



						</v-row>

					</v-card-title>

					<v-card-text>

						<v-data-table
						:headers="headers"
						:items="eslips"
						:items-per-page="5"
						:search="search"
						class="elevation-1"
					  ><template v-slot:item.documentUpload.fileName="{ item }">
						<a
						  href="#"
						  class="primary--text"
						  @click.prevent="downloadContractPDF(item)"
						>
						  {{ item.documentUpload.fileName }}
						</a>
					  </template>
				</v-data-table>
			<Loader :visible="loadingSpin" />
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                              prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import * as XLSX from 'xlsx';
import Loader from "./Loader.vue";
import _ from 'lodash'

export default {
	name: 'StockDetailStatusTracker2',
	components: {
		Loader,
	},
	data: function() {
		return {
			headers: [{
					text: 'Transaction ID',
					value: 'id'
				},
				{
					text: 'Amount',
					value: 'amount'
				},
				{
					text: 'Narration',
					value: 'narration'
				},
				{
					text: 'Running Balance',
					value: 'runningBalance'
				},
				{
					text: 'DR/CR',
					value: 'drCr'
				},
				{
					text: 'Transaction Date',
					value: 'date'
				}
			],
			loadingSpin: false,
			accountNumber: "",
			accountName: "",
			bookBalance: "",
			currencyCode: "",
			availableBalance: "",
			searchBy: "transactionID",
			searchValue: "",
			startDate: "",
			endDate: "",
			transactionId: '',
			fromDate: '',
			toDate: '',
			transactions: [{
				id: "",
				date: "",
				narration: "",
				amount: "",
				drCr: "",
				runningBalance: "",
			}, ],
			eslips: [],
			startDate: '',
			endDate: '',
			message: '',
			loading: false,
			totalEslips: 0,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			currentYear: new Date(),
			pagination: {
				sortBy: 'id',
				descending: true
			},
			dialog: false,
			eslip: {},
			search: '',
			transactionId: '',
			amount: '',
			page: 1,
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10]
		}
	},
	watch: {
		search: function(newSearch) {
			// Reset page number when search changes
			this.page = 1
			this.debouncedGetEslips()
		}
		// search: function (oldValue, newValue) {
		//   this.debouncedGetAnswer()
		// }
	},
	mounted() {
		this.getBuyerEslips()
	},
	methods: {
		goToStock(item) {
			console.log('item --->> ', item.id);
			this.$router.push('/grower/stock/' + item.id);
		},
		exportExcel() {
			// Define worksheet and workbook
			const ws = XLSX.utils.json_to_sheet(this.eslips,
				//   {
				//     header: Object.keys(this.headers)
				//   }
			);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

			// Export workbook to file
			XLSX.writeFile(wb, this.accountNumber + '_' + this.accountName + '_Statement.xlsx');
		},
		checkDate(event, dte) {},

		formatDate(dateObj) {
			const day = dateObj.dayOfMonth < 10 ? `0${dateObj.dayOfMonth}` : dateObj.dayOfMonth;
			const monthShort = dateObj.month.substring(0, 3).toUpperCase();
			const year = dateObj.year.toString().slice(-2);
			return `${day}-${monthShort}-${year}`;
		},
		getRequestParams(name, page, pageSize) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
		getRequestParams2(name, page, pageSize, startDate, endDate) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.outturnNumber = name
			}
			if (startDate) {
				params.startDate = startDate
			}
			if (endDate) {
				params.endDate = endDate
			}
			return params
		},
		loadMethod() {
			this.loadingSpin = true;
		},
		getBuyerEslips() {
			// const params = this.getRequestParams(this.search, this.page, this.pageSize)
			const params = this.getRequestParams2(this.search, this.page, this.pageSize, this.startDate, this.endDate)
			console.log("params - " + params)
			const url = config.serverURI + '/noncheckoff'
			axios.get(url, { params })
				.then(response => {
					console.log('Non-Checkoff data', response.data)
					this.accountNumber = response.data.accountNumber;
					this.accountName = response.data.accountName;
					this.bookBalance = response.data.bookBalance;
					this.currencyCode = response.data.currencyCode;
					this.availableBalance = response.data.availableBalance;
					// const {
					// 	items,
					// 	totalPages
					// } = response.data.transactions
					this.eslips = response.data.transactions
					this.totalPages = totalPages
					if (response.data !== null) {
						this.loadingSpin = false;
					} else {
						this.loadMethod();
					}

				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.eslips
		},
		debouncedGetEslips: _.debounce(function() {
			this.getBuyerEslips()
		}, 500),
		triggerDownload(item) {
			const url = config.serverURI + '/eslip/download/' + item.id
			axios({
					url: url,
					method: 'POST',
					responseType: 'blob'
				})
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.created + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		displayEslipDetails(item) {
			this.dialog = true
			this.eslip = item
		},
		hideDialog() {
			this.dialog = false
		},
		handlePageChange(value) {
			this.page = value
			this.getBuyerEslips()
		},
		handlePageSizeChange(size) {
			this.pageSize = size
			this.page = 1
			this.getBuyerEslips()
		}
	}
	// created: function () {
	//   this.debouncedGetAnswer = _.debounce(this.getGrowerStatement, 1000)
	// },

}
</script>
<style>
.search-container {
	display: flex;
	justify-content: space-between;
	margin-bottom: 1em;
}

.search-box {
	flex: 1;
	margin-right: 1em;
}

.date-filters {
	display: flex;
	gap: 1em;
}
</style>
